import { Divider } from "@material-ui/core";
import React from "react";
import CulDay from "../../../ebusHomePics/Files/culday.png";
import * as Scroll from "react-scroll";

const CulturalRules = (props) => {
  let scroll = Scroll.animateScroll;

  React.useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (
    <div className="row">
      <div className="w-100 p-0" id="jobHd">
        <div className="container w-100 h-100 d-flex align-items-center">
          <h1 className="text-white">
            <b>قوانین فرهنگی</b>
          </h1>
        </div>
      </div>
      <div className="container h-auto " style={{ marginBlock: "3rem" }}>
        <div
          className="container pt-5 bg-white landings-container"
        >
          <h2
            className="p-4 col-6 col-md-3"
            style={{ borderBottom: "2.3px solid #6dd06d" }}
          >
            <b>قوانین فرهنگی</b>
          </h2>
          <div className="d-block d-md-flex flex-wrap my-5">
            <div className="col-12 col-md-6">
              <img src={CulDay} className="w-100 h-100" />
            </div>
            <div className="col-12 col-md-6 d-flex align-items-center">
              <h2 style={{ lineHeight: "40px", textAlign: "justify" }}>
                امنیت,سلامت و راحتی مسافران یکی از مهم ترین دغدغه تیم ایباس
                است. رعایت برخی مسائل فرهنگی و اجتماعی سبب می شوند همه ی ما در
                کنار هم با آرامش و آسایش سفر کنیم و تجربه لذت بخشی از سفر داشته
                باشیم.
              </h2>
            </div>
            <Divider className="w-100 my-5 border-bottom border-dark" />
            <div
              className="col-12 d-flex align-items-baseline"
              style={{ gap: "15px" }}
            >
              <span
                class="badge badge-secondary d-flex align-items-center justify-content-center text-white"
                style={{
                  borderRadius: "100rem",
                  height: "3rem",
                  width: "3rem",
                  fontSize: "1.23rem",
                  backgroundColor: "#b4b4b4",
                }}
              >
                1
              </span>
              <h3 style={{ lineHeight: "30px", textAlign: "justify" }}>
                اولویت اول ما امنیت مسافران است و تمام تلاش ما در این جهت خواهد
                بود. نقش مهم شما در این امر بستن کمربند ایمنی در تمام طول سفر
                است.
              </h3>
            </div>
            <Divider className="w-100 my-5 border-bottom border-dark" />
            <div
              className="col-12 d-flex align-items-baseline"
              style={{ gap: "15px" }}
            >
              <span
                class="badge badge-secondary d-flex align-items-center justify-content-center text-white"
                style={{
                  borderRadius: "100rem",
                  height: "3rem",
                  width: "3rem",
                  fontSize: "1.23rem",
                  backgroundColor: "#b4b4b4",
                }}
              >
                2
              </span>
              <h3 style={{ lineHeight: "30px", textAlign: "justify" }}>
                باید بدانیم هنگامی که از یک وسیله نقلیه ی عمومی استفاده می‌کنیم،
                آن را با همه ی افراد حاضر شریک شده ایم و به حریم همسفرانمان
                احترام بگذاریم.
              </h3>
            </div>
            <Divider className="w-100 my-5 border-bottom border-dark" />{" "}
            <div
              className="col-12 d-flex align-items-baseline"
              style={{ gap: "15px" }}
            >
              <span
                class="badge badge-secondary d-flex align-items-center justify-content-center text-white"
                style={{
                  borderRadius: "100rem",
                  height: "3rem",
                  width: "3rem",
                  fontSize: "1.23rem",
                  backgroundColor: "#b4b4b4",
                }}
              >
                3
              </span>
              <h3 style={{ lineHeight: "30px", textAlign: "justify" }}>
                در مقابل وسیله نقلیه ای که در حال استفاده از آن هستیم مسئولیت
                پذیر باشیم. در تمیز و سالم نگه داشتن آن کوشا باشیم و بدانیم این
                اتوبوس متعلق به همه ی ماست.
              </h3>
            </div>
            <Divider className="w-100 my-5 border-bottom border-dark" />{" "}
            <div
              className="col-12 d-flex align-items-baseline"
              style={{ gap: "15px" }}
            >
              <span
                class="badge badge-secondary d-flex align-items-center justify-content-center text-white"
                style={{
                  borderRadius: "100rem",
                  height: "3rem",
                  width: "3rem",
                  fontSize: "1.23rem",
                  backgroundColor: "#b4b4b4",
                }}
              >
                4
              </span>
              <h3 style={{ lineHeight: "30px", textAlign: "justify" }}>
                همیشه افراد مسن,خانم های باردار و افراد دارای محدودیت حرکتی در
                اولویت هستند. این وظیفه ی انسانی ماست که شرایط این افراد را درک
                کنیم ,با آن ها همکاری کرده در صورت نیاز کمکشان کنیم.
              </h3>
            </div>
            <Divider className="w-100 my-5 border-bottom border-dark" />{" "}
            <div
              className="col-12 d-flex align-items-baseline"
              style={{ gap: "15px" }}
            >
              <span
                class="badge badge-secondary d-flex align-items-center justify-content-center text-white"
                style={{
                  borderRadius: "100rem",
                  height: "3rem",
                  width: "3rem",
                  fontSize: "1.23rem",
                  backgroundColor: "#b4b4b4",
                }}
              >
                5
              </span>
              <h3 style={{ lineHeight: "30px", textAlign: "justify" }}>
                سعی کنیم اصوات بلند تولید نکنیم. این صداها می تواند زنگ خوردن
                مکرر موبایل,فیلمی که در تبلت نگاه می کنیم یا موزیکی که با
                موبایل گوش میکنیم باشد. حتما در طول سفر هدفون همراهمان داشته
                باشیم.وسایل الکترونیکی خود را در حالت بی صدا قرار دهیم خصوصا در
                ساعات استراحت .هیچ کس علاقه ای به شنیدن داستان ها و اتفاقات
                خصوصی زندگی ما ندارد پس زمان مکالماتمان را کوتاه کنیم و در صورت
                امکان فقط به تماس های ضروری پاسخ بدهیم.
              </h3>
            </div>
            <Divider className="w-100 my-5 border-bottom border-dark" />{" "}
            <div
              className="col-12 d-flex align-items-baseline"
              style={{ gap: "15px" }}
            >
              <span
                class="badge badge-secondary d-flex align-items-center justify-content-center text-white"
                style={{
                  borderRadius: "100rem",
                  height: "3rem",
                  width: "3rem",
                  fontSize: "1.23rem",
                  backgroundColor: "#b4b4b4",
                }}
              >
                6
              </span>
              <h3 style={{ lineHeight: "30px", textAlign: "justify" }}>
                سعی کنیم از کمترین مقدار عطر و ادکلن قبل از سفر استفاده کنیم.
                ممکن است افرادی که مبتلا به اسم و آلرژی هستند در کنار شما نشسته
                باشند.دوش گرفتن و استفاده از لباس های تمیز ودر عین حال راحت ،
                مطابق با دمای اتوبوس احساس خوشایندی در طول سفر برایمان به ارمغان
                می آورد. بهتر است استفاده از عطر و ادکلن را به بعد از سفر موکول
                کنیم.
              </h3>
            </div>
            <Divider className="w-100 my-5 border-bottom border-dark" />{" "}
            <div
              className="col-12 d-flex align-items-baseline"
              style={{ gap: "15px" }}
            >
              <span
                class="badge badge-secondary d-flex align-items-center justify-content-center text-white"
                style={{
                  borderRadius: "100rem",
                  height: "3rem",
                  width: "3rem",
                  fontSize: "1.23rem",
                  backgroundColor: "#b4b4b4",
                }}
              >
                7
              </span>
              <h3 style={{ lineHeight: "30px", textAlign: "justify" }}>
                از همراه داشتن غذاهایی که بوی تند دارند خودداری کنیم. مثل غذاهای
                دودی,غذاهایی شامل تن ماهی,سوسیس,تخم مرغ آبپز و هر غذایی که
                فکر می کنیم بوی تندی در محیط پخش می کند. در عوض می توان از میوه
                تازه و خشک,آجیل,لقمه های سرد و اسنک های مقوی استفاده کرد.
              </h3>
            </div>
            <Divider className="w-100 my-5 border-bottom border-dark" />{" "}
            <div
              className="col-12 d-flex align-items-baseline"
              style={{ gap: "15px" }}
            >
              <span
                class="badge badge-secondary d-flex align-items-center justify-content-center text-white"
                style={{
                  borderRadius: "100rem",
                  height: "3rem",
                  width: "3rem",
                  fontSize: "1.23rem",
                  backgroundColor: "#b4b4b4",
                }}
              >
                8
              </span>
              <h3 style={{ lineHeight: "30px", textAlign: "justify" }}>
                در سفرهای طولانی در صورت امکان از بالشت های دور گردنی استفاده
                کنیم تا با احساس راحتی بیشتری سفر کنیم.
              </h3>
            </div>
            <Divider className="w-100 my-5 border-bottom border-dark" />{" "}
            <div
              className="col-12 d-flex align-items-baseline"
              style={{ gap: "15px" }}
            >
              <span
                class="badge badge-secondary d-flex align-items-center justify-content-center text-white"
                style={{
                  borderRadius: "100rem",
                  height: "3rem",
                  width: "3rem",
                  fontSize: "1.23rem",
                  backgroundColor: "#b4b4b4",
                }}
              >
                9
              </span>
              <h3 style={{ lineHeight: "30px", textAlign: "justify" }}>
                قبل از سفر درباره ی چگونگی رفتار در مکان های عمومی و حفظ سکوت و
                آرامش با فرزندان خود صحبت کنیم تا در آرامش سفر کنیم.
              </h3>
            </div>
            <Divider className="w-100 my-5 border-bottom border-dark" />{" "}
            <div
              className="col-12 d-flex align-items-baseline"
              style={{ gap: "15px" }}
            >
              <span
                class="badge badge-secondary d-flex align-items-center justify-content-center text-white"
                style={{
                  borderRadius: "100rem",
                  height: "3rem",
                  width: "3rem",
                  backgroundColor: "#b4b4b4",
                  fontSize: "1.23rem",
                }}
              >
                10
              </span>
              <h3 style={{ lineHeight: "30px", textAlign: "justify" }}>
                برای رفاه حال همه ی همسفرانمان تحت هیچ شرایطی کفش هایمان را
                درنیاوریم.
              </h3>
            </div>
            <Divider className="w-100 my-5 border-bottom border-dark" />{" "}
            <div
              className="col-12 d-flex align-items-baseline"
              style={{ gap: "15px" }}
            >
              <span
                class="badge badge-secondary d-flex align-items-center justify-content-center text-white"
                style={{
                  borderRadius: "100rem",
                  height: "3rem",
                  width: "3rem",
                  backgroundColor: "#b4b4b4",
                  fontSize: "1.23rem",
                }}
              >
                11
              </span>
              <h3 style={{ lineHeight: "30px", textAlign: "justify" }}>
                ممکن است دمایی که برای ما مطبوع است برای همسفرمان سرد یا گرم
                باشد پس برای رفاه حال خودمان لباس مناسب و در صورت امکان یک پتوی
                کوچک همراه داشته باشیم.
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CulturalRules;
